// Site/SiteForm/CharacterCounter.jsx
import React from "react";

const CharacterCounter = ({ current = "", max }) => (
  <div className="text-xs text-gray-500 mt-1 text-right">
    {current.length} / {max} characters
  </div>
);

export default CharacterCounter;
